import { useContext, useEffect } from "react";
import { NewMessageCenter } from "../components/NewMessageCenter";
import { LayoutContext } from "../contexts/LayoutContext";
import Header from "../components/shared/TailwindComponents/Header";

function MessageCenterPage() {
  const { setIsContentScrollable } = useContext(LayoutContext);

  useEffect(() => {
    setIsContentScrollable(false);
    document.body.style.overflow = 'hidden';

    return () => {
      setIsContentScrollable(true);
      document.body.style.overflow = '';
    };
  }, [setIsContentScrollable]);

  return (
    <div className="h-screen flex flex-col">
      <Header />
      <NewMessageCenter />
    </div>
  )
}

export default MessageCenterPage;
